import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import ContentState from '../../../../stores/ContentState'
import CustomSlider from '../../../common/CustomSlider'
import Parallax from '../../../common/Parallax'
import './index.scss'
import { ReactComponent as ArrowLeft } from '../../../../assets/arrow-left.svg'
import classNames from 'classnames'
import Slider from 'react-slick'

const Future = observer(() => {
  const slider = useRef<any>(null)
  const [width, setWidth] = useState(window.innerWidth)
  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    variableWidth: true,
    appendArrows: '.friendly-block__future-btns',
    slidesToShow: width > 1700 || width > 900 ? 2 : 1,
    slidesToScroll: width > 1700 || width > 900 ? 2 : 1,
  }

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  if (!ContentState.about?.friendly.future) return <></>

  let arr: any = []
  for (
    let i = 0;
    i < 60 / ContentState.about?.friendly?.future.slides?.length;
    i++
  ) {
    ContentState.about?.friendly?.future.slides?.forEach((f: any) =>
      arr.push(f),
    )
  }
  return (
    <div className="friendly-block__future">
      <div className="friendly-block__future-top">
        <div
          className="friendly-block__apps-title"
          dangerouslySetInnerHTML={{
            __html: ContentState.about.friendly.future.title,
          }}
        ></div>
        <div className="we-block__terminals-btns">
          <div
            className={classNames('we-block__terminals-btn back')}
            onClick={() => slider.current?.slickPrev()}
          >
            <ArrowLeft />
          </div>
          <div
            className={classNames('we-block__terminals-btn next')}
            onClick={() => slider.current?.slickNext()}
          >
            <ArrowLeft />
          </div>
        </div>
      </div>
      <div
        style={{
          marginRight: width > 480 ? -30 : -20,
        }}
      >
        <div className="friendly-block__future-list">
          <Slider {...settings} ref={slider}>
            {arr.map((s: any, i: number) => (
              <div className="friendly-block__future-slide" key={i}>
                <div className="friendly-block__future-img">
                  {s.src && <Parallax src={s.src} />}
                </div>
                <div className="friendly-block__future-col">
                  <div className="friendly-block__future-title">{s.title}</div>
                  <div
                    className="friendly-block__future-text"
                    dangerouslySetInnerHTML={{ __html: s.text }}
                  ></div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <div className="we-block__terminals-btns">
        <div
          className={classNames('we-block__terminals-btn back')}
          onClick={() => slider.current?.slickPrev()}
        >
          <ArrowLeft />
        </div>
        <div
          className={classNames('we-block__terminals-btn next')}
          onClick={() => slider.current?.slickNext()}
        >
          <ArrowLeft />
        </div>
      </div>
    </div>
  )
})

export default Future
